define(function(require) {
  var IpsModelCollection = require('civicsBase/ipsModelCollection');
  return IpsModelCollection.extend({
    urlRoot: '/delegate/civics-api/api/cdr/inspections/{0}/{1}/logs'
  });
});
